<form class="form-inline">
  <div class="form-group" style="display: flex; align-items: center; gap: 10px;margin-top: 15px;">
    <label style="margin-left: 20px; white-space: nowrap;">Zone</label>
    <ng-select
      [multiple]="true"
      [closeOnSelect]="false"
      bindLabel="text"
      bindValue="id"
      [items]="zoneItems"
      placeholder="select authorité"
      [compareWith]="compareZones"
      [(ngModel)]="zonesSelected"
      (change)="selectedzone($event)"
      style="max-width: 400px;margin-left: 20px;border-radius: 25px">
    </ng-select>

    <input *ngIf="!stopTimeSelectMode" type="number" name="stopTime" [(ngModel)]="zoneAlertConfiguration.value2" class="form-control"
      placeholder="Durée d'arrêt" >
    <i *ngIf="!stopTimeSelectMode" class="fa fa-times" style="color: #aa1111" (click)="stopTimeSelectMode = true;zoneAlertConfiguration.value2='10'" style="width: 5px"></i>
  </div>


  <!-----------------email section---------------->
<div class="email-manager" style="margin-left: 20px;margin-top: 20px;">
  <app-email-manager [enableGlobalConfigToAllVehicules]="enableGlobalConfigToAllVehicules" [emailMode]="alert.emailMode" [enableGlobalConfig]="enableGlobalConfig" [emailsHash]="alert.emails" (onChange)="emailSettings($event)"></app-email-manager>
</div>


<!--------------------------activer alert section--------------------->
  <div class="form-group" style="margin-top: -45px;margin-left: 480px">
    <label style="font-size: 12px;margin-right: 10px">Activer l'alert</label>
    <div class="input-group">
      <mat-slide-toggle [(ngModel)]="alert.isActive" name="isActive" ></mat-slide-toggle>
    </div>
  </div>







  <div  class="advanced-link" style="margin-left: 16px;margin-top: 10px;" *ngIf="!showAdvancedSettings" (click)="collapseAdvancedSettings()">
    <span class="link" style="margin-right: 10px;  text-decoration: none;">paramétrage avancé</span>
    <i class="fa fa-plus-square"></i>
  </div>

  <div class="advanced-link" style="margin-left: 16px;margin-top: 10px" *ngIf="showAdvancedSettings" (click)="collapseAdvancedSettings()">

    <span class="link"  style="margin-right: 10px;  text-decoration: none;">masquer paramétrage avancé</span>
    <i class="fa fa-minus-square"></i>
  </div>
<div style="margin-left: 25px;margin-top: 15px">
  <app-cron-settings *ngIf="showAdvancedSettings" [cron]="cronAlertConfiguration"></app-cron-settings>

</div>









  <button type="submit" class="btn btn-flat btn-primary pull-right" style="margin-top: 45px;border-radius: 15px" (click)="save()">
        Sauvegarder
  </button>

</form>

<ngx-loading [show]="loader" [config]="{ backdropBorderRadius: '0px',fullScreenBackdrop:true }"></ngx-loading>
